export default "__VITE_ASSET__BoRLK8z7__"